import React from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useAuth } from "../../../context/auth-context";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const Dashboards = () => {

    const auth = useAuth();

  const invoiceData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Invoices",
        data: [120, 200, 150, 180, 220],
        backgroundColor: "#3b82f6",
        borderColor: "#2563eb",
        borderWidth: 1,
      },
    ],
  };

  const paymentsData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Payments",
        data: [100, 190, 140, 170, 210],
        borderColor: "#10b981",
        backgroundColor: "rgba(16, 185, 129, 0.2)",
        fill: true,
      },
    ],
  };

  const expenseData = {
    labels: ["Salaries", "Supplies", "Travel", "Utilities", "Misc"],
    datasets: [
      {
        label: "Expenses",
        data: [4000, 1200, 1800, 1000, 800],
        backgroundColor: [
          "#ef4444",
          "#3b82f6",
          "#f59e0b",
          "#10b981",
          "#6366f1",
        ],
      },
    ],
  };
  

  return (
    <div className="min-h-screen flex">
      

      {/* Main Content */}
      <main className="flex-1 p-8">
        {/* Header */}
        <header className="mb-8 flex justify-between items-center">
          <h1 className="text-2xl font-semibold text-gray-700">
            Welcome, {auth.user?.email} !
          </h1>
         
        </header>

        {/* KPI Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              Total Invoices
            </h3>
            <p className="text-2xl font-bold text-blue-600">2,450</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              Payments Received
            </h3>
            <p className="text-2xl font-bold text-green-600">K1,500</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              Outstanding Balance
            </h3>
            <p className="text-2xl font-bold text-red-600">K950</p>
          </div>
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-lg font-semibold mb-4 text-gray-700">
              Invoices Overview
            </h2>
            <Bar data={invoiceData} />
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-lg font-semibold mb-4 text-gray-700">
              Payments Overview
            </h2>
            <Line data={paymentsData} />
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-lg font-semibold mb-4 text-gray-700">
              Expense Breakdown
            </h2>
            <Pie data={expenseData} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboards;
